import React, { Component } from 'react'
import { connect } from 'react-redux'
import { DocumentsComponent } from '../components'
import { updateRequestState, getRequestState } from '../../../shared/actions'

class Documents extends Component {
    constructor(props) {
        super(props)

        this.state = {
            phoneNumber: '',
            needToForward: props.history.location.params && props.history.location.params.needToForward
        }
    }

    componentDidMount = () => {
        this.props.getRequestState()
    }

    goToScreen = (key, params) => {
        this.props.history.push({
            pathname: key,
            params: params
        })
    }

    goBack = () => {
        this.props.history.replace("addressVerification")
    }

    handleChange = (key, value) => {
        this.setState({ [key]: value })
    }

    send = () => {
        this.props.updateRequestState({
            state: "candidate_availability_captured",
            data: {
                availability: "not_available",
                not_available_reason: "forward_to_parents",
                parents_phone: this.state.phoneNumber
            },
            nextRoute: 'thankyou'
        })
    }

    render() {
        const { language, languageJSON } = this.props
        const { phoneNumber, needToForward } = this.state
        return (
            <DocumentsComponent
                phoneNumber={phoneNumber}
                needToForward={needToForward}
                handleChange={this.handleChange}
                goBack={this.goBack}
                goToScreen={this.goToScreen}
                language={language}
                languageJSON={languageJSON}
                send={this.send}
            />
        )
    }
}

const mapStateToProps = ({ language: { language, languageJSON } }) => ({
    language,
    languageJSON
})

export default connect(mapStateToProps, { updateRequestState, getRequestState })(Documents)
